import { RestClient } from "./restClient";
import { RealtimeClient } from "./RealtimeClient";

export class RuleService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
		this._rc = new RealtimeClient();
	}

	streamRules(optionalEntityId, callback) {
		const args = {
			filterType: "all",
			entityId: optionalEntityId
		};

		return this._rc.subscribe("rules-app", "/rules", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	rulesExistForEventType(eventTypeId, callback) {
		const url = `/rules-app/api/rules/existForEventType/${eventTypeId}`;
		this._restClient.exec_get(url, callback);
	}

	rulesExistForEventPriority(eventPriorityId, callback) {
		const url = `/rules-app/api/rules/existForEventPriority/${eventPriorityId}`;
		this._restClient.exec_get(url, callback);
	}

	getRuleConditions(callback) {
		const url = "/rules-app/api/ruleConditions";
		this._restClient.exec_get(url, callback);
	}
}
